/**
 * Repositorio CRUD de Banners (catálogo)
 */

import FirestoreService from './firestore.service.js';
import stateManager from '../core/stateManager.js';
import { COLLECTIONS } from '../config/firestore.js';

const OPTS = { entityName: 'banners' };

class BannerRepository {
  static async findAll() {
    const docs = await FirestoreService.findAll(COLLECTIONS.BANNERS, null, OPTS);
    return docs.map(this.#toBanner);
  }

  static async findById(id) {
    const doc = await FirestoreService.findById(COLLECTIONS.BANNERS, id, OPTS);
    return doc ? this.#toBanner(doc) : null;
  }

  static async create(data) {
    const payload = this.#toFirestore(data);
    return FirestoreService.create(COLLECTIONS.BANNERS, payload, OPTS);
  }

  static async update(id, data) {
    const payload = this.#toFirestore(data);
    return FirestoreService.update(COLLECTIONS.BANNERS, id, payload, OPTS);
  }

  static async remove(id) {
    return FirestoreService.delete(COLLECTIONS.BANNERS, id, OPTS);
  }

  static async loadIntoState() {
    const banners = await this.findAll();
    banners.forEach((b) =>
      stateManager.setEntity('banners', b.id, b, 'create')
    );
    return banners;
  }

  static #toBanner(doc) {
    return {
      id: doc.id,
      title: doc.title ?? '',
      description: doc.description ?? '',
      icon: doc.icon ?? '',
      iconAnimated: doc.iconAnimated === true,
      imageUrl: doc.imageUrl ?? '',
      order: doc.order ?? 0,
      active: doc.active ?? false,
      startDate: doc.startDate ? new Date(doc.startDate.seconds * 1000) : null,
      endDate: doc.endDate ? new Date(doc.endDate.seconds * 1000) : null,
      link: doc.link ?? '',
      createdAt: doc.createdAt ? new Date(doc.createdAt.seconds * 1000) : new Date(),
      updatedAt: doc.updatedAt ? new Date(doc.updatedAt.seconds * 1000) : new Date()
    };
  }

  static #toFirestore(banner) {
    return {
      title: banner.title,
      description: banner.description,
      icon: banner.icon,
      iconAnimated: banner.iconAnimated === true,
      imageUrl: banner.imageUrl,
      order: banner.order,
      active: banner.active,
      startDate: banner.startDate,
      endDate: banner.endDate,
      link: banner.link,
      createdAt: banner.createdAt || new Date(),
      updatedAt: new Date()
    };
  }
}

export default BannerRepository;